import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=62882d71&scoped=true"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"
import style0 from "./MainMenu.vue?vue&type=style&index=0&id=62882d71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62882d71",
  null
  
)

export default component.exports